import { productCarouselProductStyles as styles } from "@insite/content-library/Components/ProductCarouselProduct";
import { css } from "styled-components";

styles.productPartNumbersStyles = {
    container: {
        css: css`
            flex-grow: 1;
        `,
    },
};
